/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as WelcomeRouteImport } from "./routes/welcome"
import { Route as WaitlistRouteImport } from "./routes/waitlist"
import { Route as ScheduleRouteImport } from "./routes/schedule"
import { Route as DevRouteImport } from "./routes/dev"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as AboutRouteImport } from "./routes/about"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as ProducerIndexRouteImport } from "./routes/producer/index"
import { Route as PatientIndexRouteImport } from "./routes/patient/index"
import { Route as AuthIndexRouteImport } from "./routes/auth/index"
import { Route as AppointmentIndexRouteImport } from "./routes/appointment/index"
import { Route as TreatmentPatientIdRouteImport } from "./routes/treatment/$patientId"
import { Route as ProducerNewRouteImport } from "./routes/producer/new"
import { Route as ProducerProducerIdRouteImport } from "./routes/producer/$producerId"
import { Route as PrescriptionPatientIdRouteImport } from "./routes/prescription/$patientId"
import { Route as PatientNewRouteImport } from "./routes/patient/new"
import { Route as PatientMeRouteImport } from "./routes/patient/me"
import { Route as PatientAddressRouteImport } from "./routes/patient/address"
import { Route as PatientPatientIdRouteImport } from "./routes/patient/$patientId"
import { Route as IntakePatientIdRouteImport } from "./routes/intake/$patientId"
import { Route as DetailsPatientIdRouteImport } from "./routes/details/$patientId"
import { Route as AuthResetPasswordRouteImport } from "./routes/auth/reset-password"
import { Route as AuthPractitionersRouteImport } from "./routes/auth/practitioners"
import { Route as AuthLogoutRouteImport } from "./routes/auth/logout"
import { Route as AuthBootstrapRouteImport } from "./routes/auth/bootstrap"
import { Route as AuthAttachmentTypesRouteImport } from "./routes/auth/attachment-types"
import { Route as AuthAdminRouteImport } from "./routes/auth/admin"
import { Route as AuthAccountRouteImport } from "./routes/auth/account"
import { Route as AttachmentsPatientIdRouteImport } from "./routes/attachments/$patientId"
import { Route as AppointmentPatientIdRouteImport } from "./routes/appointment/$patientId"

const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: "/waitlist",
  path: "/waitlist",
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: "/schedule",
  path: "/schedule",
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: "/dev",
  path: "/dev",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerIndexRoute = ProducerIndexRouteImport.update({
  id: "/producer/",
  path: "/producer/",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientIndexRoute = PatientIndexRouteImport.update({
  id: "/patient/",
  path: "/patient/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: "/auth/",
  path: "/auth/",
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentIndexRoute = AppointmentIndexRouteImport.update({
  id: "/appointment/",
  path: "/appointment/",
  getParentRoute: () => rootRouteImport,
} as any)
const TreatmentPatientIdRoute = TreatmentPatientIdRouteImport.update({
  id: "/treatment/$patientId",
  path: "/treatment/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerNewRoute = ProducerNewRouteImport.update({
  id: "/producer/new",
  path: "/producer/new",
  getParentRoute: () => rootRouteImport,
} as any)
const ProducerProducerIdRoute = ProducerProducerIdRouteImport.update({
  id: "/producer/$producerId",
  path: "/producer/$producerId",
  getParentRoute: () => rootRouteImport,
} as any)
const PrescriptionPatientIdRoute = PrescriptionPatientIdRouteImport.update({
  id: "/prescription/$patientId",
  path: "/prescription/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientNewRoute = PatientNewRouteImport.update({
  id: "/patient/new",
  path: "/patient/new",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientMeRoute = PatientMeRouteImport.update({
  id: "/patient/me",
  path: "/patient/me",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientAddressRoute = PatientAddressRouteImport.update({
  id: "/patient/address",
  path: "/patient/address",
  getParentRoute: () => rootRouteImport,
} as any)
const PatientPatientIdRoute = PatientPatientIdRouteImport.update({
  id: "/patient/$patientId",
  path: "/patient/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const IntakePatientIdRoute = IntakePatientIdRouteImport.update({
  id: "/intake/$patientId",
  path: "/intake/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const DetailsPatientIdRoute = DetailsPatientIdRouteImport.update({
  id: "/details/$patientId",
  path: "/details/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/auth/reset-password",
  path: "/auth/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPractitionersRoute = AuthPractitionersRouteImport.update({
  id: "/auth/practitioners",
  path: "/auth/practitioners",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: "/auth/logout",
  path: "/auth/logout",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthBootstrapRoute = AuthBootstrapRouteImport.update({
  id: "/auth/bootstrap",
  path: "/auth/bootstrap",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAttachmentTypesRoute = AuthAttachmentTypesRouteImport.update({
  id: "/auth/attachment-types",
  path: "/auth/attachment-types",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: "/auth/admin",
  path: "/auth/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: "/auth/account",
  path: "/auth/account",
  getParentRoute: () => rootRouteImport,
} as any)
const AttachmentsPatientIdRoute = AttachmentsPatientIdRouteImport.update({
  id: "/attachments/$patientId",
  path: "/attachments/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentPatientIdRoute = AppointmentPatientIdRouteImport.update({
  id: "/appointment/$patientId",
  path: "/appointment/$patientId",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/schedule": typeof ScheduleRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/appointment/$patientId": typeof AppointmentPatientIdRoute
  "/attachments/$patientId": typeof AttachmentsPatientIdRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/attachment-types": typeof AuthAttachmentTypesRoute
  "/auth/bootstrap": typeof AuthBootstrapRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/auth/practitioners": typeof AuthPractitionersRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/details/$patientId": typeof DetailsPatientIdRoute
  "/intake/$patientId": typeof IntakePatientIdRoute
  "/patient/$patientId": typeof PatientPatientIdRoute
  "/patient/address": typeof PatientAddressRoute
  "/patient/me": typeof PatientMeRoute
  "/patient/new": typeof PatientNewRoute
  "/prescription/$patientId": typeof PrescriptionPatientIdRoute
  "/producer/$producerId": typeof ProducerProducerIdRoute
  "/producer/new": typeof ProducerNewRoute
  "/treatment/$patientId": typeof TreatmentPatientIdRoute
  "/appointment/": typeof AppointmentIndexRoute
  "/auth/": typeof AuthIndexRoute
  "/patient/": typeof PatientIndexRoute
  "/producer/": typeof ProducerIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/schedule": typeof ScheduleRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/appointment/$patientId": typeof AppointmentPatientIdRoute
  "/attachments/$patientId": typeof AttachmentsPatientIdRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/attachment-types": typeof AuthAttachmentTypesRoute
  "/auth/bootstrap": typeof AuthBootstrapRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/auth/practitioners": typeof AuthPractitionersRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/details/$patientId": typeof DetailsPatientIdRoute
  "/intake/$patientId": typeof IntakePatientIdRoute
  "/patient/$patientId": typeof PatientPatientIdRoute
  "/patient/address": typeof PatientAddressRoute
  "/patient/me": typeof PatientMeRoute
  "/patient/new": typeof PatientNewRoute
  "/prescription/$patientId": typeof PrescriptionPatientIdRoute
  "/producer/$producerId": typeof ProducerProducerIdRoute
  "/producer/new": typeof ProducerNewRoute
  "/treatment/$patientId": typeof TreatmentPatientIdRoute
  "/appointment": typeof AppointmentIndexRoute
  "/auth": typeof AuthIndexRoute
  "/patient": typeof PatientIndexRoute
  "/producer": typeof ProducerIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/schedule": typeof ScheduleRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/appointment/$patientId": typeof AppointmentPatientIdRoute
  "/attachments/$patientId": typeof AttachmentsPatientIdRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/attachment-types": typeof AuthAttachmentTypesRoute
  "/auth/bootstrap": typeof AuthBootstrapRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/auth/practitioners": typeof AuthPractitionersRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/details/$patientId": typeof DetailsPatientIdRoute
  "/intake/$patientId": typeof IntakePatientIdRoute
  "/patient/$patientId": typeof PatientPatientIdRoute
  "/patient/address": typeof PatientAddressRoute
  "/patient/me": typeof PatientMeRoute
  "/patient/new": typeof PatientNewRoute
  "/prescription/$patientId": typeof PrescriptionPatientIdRoute
  "/producer/$producerId": typeof ProducerProducerIdRoute
  "/producer/new": typeof ProducerNewRoute
  "/treatment/$patientId": typeof TreatmentPatientIdRoute
  "/appointment/": typeof AppointmentIndexRoute
  "/auth/": typeof AuthIndexRoute
  "/patient/": typeof PatientIndexRoute
  "/producer/": typeof ProducerIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/schedule"
    | "/waitlist"
    | "/welcome"
    | "/appointment/$patientId"
    | "/attachments/$patientId"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/attachment-types"
    | "/auth/bootstrap"
    | "/auth/logout"
    | "/auth/practitioners"
    | "/auth/reset-password"
    | "/details/$patientId"
    | "/intake/$patientId"
    | "/patient/$patientId"
    | "/patient/address"
    | "/patient/me"
    | "/patient/new"
    | "/prescription/$patientId"
    | "/producer/$producerId"
    | "/producer/new"
    | "/treatment/$patientId"
    | "/appointment/"
    | "/auth/"
    | "/patient/"
    | "/producer/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/schedule"
    | "/waitlist"
    | "/welcome"
    | "/appointment/$patientId"
    | "/attachments/$patientId"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/attachment-types"
    | "/auth/bootstrap"
    | "/auth/logout"
    | "/auth/practitioners"
    | "/auth/reset-password"
    | "/details/$patientId"
    | "/intake/$patientId"
    | "/patient/$patientId"
    | "/patient/address"
    | "/patient/me"
    | "/patient/new"
    | "/prescription/$patientId"
    | "/producer/$producerId"
    | "/producer/new"
    | "/treatment/$patientId"
    | "/appointment"
    | "/auth"
    | "/patient"
    | "/producer"
  id:
    | "__root__"
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/schedule"
    | "/waitlist"
    | "/welcome"
    | "/appointment/$patientId"
    | "/attachments/$patientId"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/attachment-types"
    | "/auth/bootstrap"
    | "/auth/logout"
    | "/auth/practitioners"
    | "/auth/reset-password"
    | "/details/$patientId"
    | "/intake/$patientId"
    | "/patient/$patientId"
    | "/patient/address"
    | "/patient/me"
    | "/patient/new"
    | "/prescription/$patientId"
    | "/producer/$producerId"
    | "/producer/new"
    | "/treatment/$patientId"
    | "/appointment/"
    | "/auth/"
    | "/patient/"
    | "/producer/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DashboardRoute: typeof DashboardRoute
  DevRoute: typeof DevRoute
  ScheduleRoute: typeof ScheduleRoute
  WaitlistRoute: typeof WaitlistRoute
  WelcomeRoute: typeof WelcomeRoute
  AppointmentPatientIdRoute: typeof AppointmentPatientIdRoute
  AttachmentsPatientIdRoute: typeof AttachmentsPatientIdRoute
  AuthAccountRoute: typeof AuthAccountRoute
  AuthAdminRoute: typeof AuthAdminRoute
  AuthAttachmentTypesRoute: typeof AuthAttachmentTypesRoute
  AuthBootstrapRoute: typeof AuthBootstrapRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthPractitionersRoute: typeof AuthPractitionersRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  DetailsPatientIdRoute: typeof DetailsPatientIdRoute
  IntakePatientIdRoute: typeof IntakePatientIdRoute
  PatientPatientIdRoute: typeof PatientPatientIdRoute
  PatientAddressRoute: typeof PatientAddressRoute
  PatientMeRoute: typeof PatientMeRoute
  PatientNewRoute: typeof PatientNewRoute
  PrescriptionPatientIdRoute: typeof PrescriptionPatientIdRoute
  ProducerProducerIdRoute: typeof ProducerProducerIdRoute
  ProducerNewRoute: typeof ProducerNewRoute
  TreatmentPatientIdRoute: typeof TreatmentPatientIdRoute
  AppointmentIndexRoute: typeof AppointmentIndexRoute
  AuthIndexRoute: typeof AuthIndexRoute
  PatientIndexRoute: typeof PatientIndexRoute
  ProducerIndexRoute: typeof ProducerIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/welcome": {
      id: "/welcome"
      path: "/welcome"
      fullPath: "/welcome"
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/waitlist": {
      id: "/waitlist"
      path: "/waitlist"
      fullPath: "/waitlist"
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/schedule": {
      id: "/schedule"
      path: "/schedule"
      fullPath: "/schedule"
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev": {
      id: "/dev"
      path: "/dev"
      fullPath: "/dev"
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/about": {
      id: "/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/producer/": {
      id: "/producer/"
      path: "/producer"
      fullPath: "/producer/"
      preLoaderRoute: typeof ProducerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/": {
      id: "/patient/"
      path: "/patient"
      fullPath: "/patient/"
      preLoaderRoute: typeof PatientIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/": {
      id: "/auth/"
      path: "/auth"
      fullPath: "/auth/"
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/appointment/": {
      id: "/appointment/"
      path: "/appointment"
      fullPath: "/appointment/"
      preLoaderRoute: typeof AppointmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/treatment/$patientId": {
      id: "/treatment/$patientId"
      path: "/treatment/$patientId"
      fullPath: "/treatment/$patientId"
      preLoaderRoute: typeof TreatmentPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/producer/new": {
      id: "/producer/new"
      path: "/producer/new"
      fullPath: "/producer/new"
      preLoaderRoute: typeof ProducerNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/producer/$producerId": {
      id: "/producer/$producerId"
      path: "/producer/$producerId"
      fullPath: "/producer/$producerId"
      preLoaderRoute: typeof ProducerProducerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/prescription/$patientId": {
      id: "/prescription/$patientId"
      path: "/prescription/$patientId"
      fullPath: "/prescription/$patientId"
      preLoaderRoute: typeof PrescriptionPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/new": {
      id: "/patient/new"
      path: "/patient/new"
      fullPath: "/patient/new"
      preLoaderRoute: typeof PatientNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/me": {
      id: "/patient/me"
      path: "/patient/me"
      fullPath: "/patient/me"
      preLoaderRoute: typeof PatientMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/address": {
      id: "/patient/address"
      path: "/patient/address"
      fullPath: "/patient/address"
      preLoaderRoute: typeof PatientAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/patient/$patientId": {
      id: "/patient/$patientId"
      path: "/patient/$patientId"
      fullPath: "/patient/$patientId"
      preLoaderRoute: typeof PatientPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/intake/$patientId": {
      id: "/intake/$patientId"
      path: "/intake/$patientId"
      fullPath: "/intake/$patientId"
      preLoaderRoute: typeof IntakePatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/details/$patientId": {
      id: "/details/$patientId"
      path: "/details/$patientId"
      fullPath: "/details/$patientId"
      preLoaderRoute: typeof DetailsPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/auth/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/practitioners": {
      id: "/auth/practitioners"
      path: "/auth/practitioners"
      fullPath: "/auth/practitioners"
      preLoaderRoute: typeof AuthPractitionersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/logout": {
      id: "/auth/logout"
      path: "/auth/logout"
      fullPath: "/auth/logout"
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/bootstrap": {
      id: "/auth/bootstrap"
      path: "/auth/bootstrap"
      fullPath: "/auth/bootstrap"
      preLoaderRoute: typeof AuthBootstrapRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/attachment-types": {
      id: "/auth/attachment-types"
      path: "/auth/attachment-types"
      fullPath: "/auth/attachment-types"
      preLoaderRoute: typeof AuthAttachmentTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/admin": {
      id: "/auth/admin"
      path: "/auth/admin"
      fullPath: "/auth/admin"
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/account": {
      id: "/auth/account"
      path: "/auth/account"
      fullPath: "/auth/account"
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/attachments/$patientId": {
      id: "/attachments/$patientId"
      path: "/attachments/$patientId"
      fullPath: "/attachments/$patientId"
      preLoaderRoute: typeof AttachmentsPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/appointment/$patientId": {
      id: "/appointment/$patientId"
      path: "/appointment/$patientId"
      fullPath: "/appointment/$patientId"
      preLoaderRoute: typeof AppointmentPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DashboardRoute: DashboardRoute,
  DevRoute: DevRoute,
  ScheduleRoute: ScheduleRoute,
  WaitlistRoute: WaitlistRoute,
  WelcomeRoute: WelcomeRoute,
  AppointmentPatientIdRoute: AppointmentPatientIdRoute,
  AttachmentsPatientIdRoute: AttachmentsPatientIdRoute,
  AuthAccountRoute: AuthAccountRoute,
  AuthAdminRoute: AuthAdminRoute,
  AuthAttachmentTypesRoute: AuthAttachmentTypesRoute,
  AuthBootstrapRoute: AuthBootstrapRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthPractitionersRoute: AuthPractitionersRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  DetailsPatientIdRoute: DetailsPatientIdRoute,
  IntakePatientIdRoute: IntakePatientIdRoute,
  PatientPatientIdRoute: PatientPatientIdRoute,
  PatientAddressRoute: PatientAddressRoute,
  PatientMeRoute: PatientMeRoute,
  PatientNewRoute: PatientNewRoute,
  PrescriptionPatientIdRoute: PrescriptionPatientIdRoute,
  ProducerProducerIdRoute: ProducerProducerIdRoute,
  ProducerNewRoute: ProducerNewRoute,
  TreatmentPatientIdRoute: TreatmentPatientIdRoute,
  AppointmentIndexRoute: AppointmentIndexRoute,
  AuthIndexRoute: AuthIndexRoute,
  PatientIndexRoute: PatientIndexRoute,
  ProducerIndexRoute: ProducerIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
